module.exports = __webpack_public_path__ + "static/media/ServicesActive.76a3d5a8.png";